"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {},
  data: function data() {
    return {
      modal2: false,
      result: []
    };
  },
  mounted: function mounted() {},
  methods: {
    // 查询详情
    initOpen: function initOpen(result) {
      this.result = result || [];
      this.modal2 = true;
    }
  }
};